import loadLabel from "@gqlapp/config/country/json";

/**
 *
 * @param code
 */
export default function c(code: string){
	return loadLabel[code] || '';
}